import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const setup: RouteRecordRaw = {
  name: 'admin.setup',
  path: 'setup',
  component: () => import('pages/Setup.vue'),
  meta: {
    roles: [Roles.OrgAdmin, Roles.SuperAdmin],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
